import { useLocation, useNavigate } from "react-router-dom";
import {
  GeneralSidebarSettingItems,
  SidebarSettingsItem,
  UserSidebarSettingItems,
} from "../../constant/data";
import { Settings } from "../../pages/home/Settings";
import NavigatebackBtn from "../generic/NavigateBackBtn";
import { useEffect, useState } from "react";

const SettingsSideBar = (props: any) => {
  const navigate = useNavigate();
  const path = useLocation().pathname;
  var pathname = path.substring(path.lastIndexOf("/") + 1);

  return (
    <div className="bg-white  min-h-[80vh] p-4 rounded-[20px] ">
      <div className="py-4">
        {/* <NavigatebackBtn
          style={"inline mr-2 "}
          onclick={() => {
            navigate('/home');
          }}
        />{" "} */}
        <p className="font-medium text-gray-700 inline ">Settings</p>
      </div>
      <p className="font-medium text-gray-700 inline text-sm ">General</p>
      {GeneralSidebarSettingItems.map((item) => (
        <p
          className={` p-3  m-2 cursor-pointer text-sm  rounded-[10px] capitalize ${
            item.path.includes(pathname)
              ? "bg-faint text-primary"
              : "text-textbg "
          } font-medium`}
          onClick={() => {
 
          navigate(`/home/settings/${item.path}`)
            
          }}
        >
          {item.icon}
          {"  "} {item.title}
        </p>
      ))}
      <p className="font-medium text-gray-700 inline text-sm ">Company</p>
      {UserSidebarSettingItems.map((item) => (
        <p
          className={` p-3  m-2 cursor-pointer text-sm  rounded-[10px] capitalize ${
            item.path.includes(pathname)
              ? "bg-faint text-primary"
              : "text-textbg "
          } font-medium`}
          onClick={() => {
            props.isusersettings
              ? navigate(`/home/settings/${item.path}`)
              : navigate(`/home/orgsettings/${item.path}`);
          }}
        >
          {item.icon}
          {"  "} {item.title}
        </p>
      ))}
    </div>
  );
};

export default SettingsSideBar;
